import { render, staticRenderFns } from "./Sizes.vue?vue&type=template&id=3f5d6798&scoped=true"
import script from "./Sizes.vue?vue&type=script&lang=js"
export * from "./Sizes.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Sizes.vue?vue&type=style&index=0&id=3f5d6798&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3f5d6798",
  null
  ,true
)

export default component.exports